import { Plus } from "lucide-react";
import { Button } from "../../../../components/ui/common/button";

interface IngredientListHeaderProps {
  onRegisterClick: () => void;
}

/**
 * Always renders the "LCA Ingredients" page heading — it's the one page
 * title for this screen wherever it's used. When nested inside
 * `BillOfMaterial` (BOM/chemical flow enabled), that screen suppresses its
 * own "Bill Of Material" title instead of this one, so the two never show
 * together (see src/screens/ingredients/BillOfMaterial.tsx).
 *
 * Styled after the Recipe Simulator list header
 * (src/screens/recipe_simulator/newList/components/RecipeListHeader.tsx).
 */
const IngredientListHeader = ({ onRegisterClick }: IngredientListHeaderProps) => {
  return (
    <div className="tw-mb-6 tw-flex tw-items-center tw-justify-between tw-gap-4">
      <div>
        <h1 className="tw-text-2xl tw-font-bold tw-text-foreground">Ingredients</h1>
        <p className="tw-mt-1 tw-text-sm tw-text-muted-foreground">
          Registered ingredients, their suppliers, unit sizes and climate change impact
        </p>
      </div>
      <Button onClick={onRegisterClick} className="tw-shrink-0 tw-gap-2">
        <Plus className="tw-h-4 tw-w-4" />
        Register New Ingredient
      </Button>
    </div>
  );
};

export default IngredientListHeader;
